export function formatUSD(amount: number, decimalPlaces: number = 2): string {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimalPlaces, // No decimal places
    }).format(amount);
  }

  export function formatMinerUSD(amount: number): string {
    const decimalPlaces = amount > 10 ? 2 : 6;
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      minimumFractionDigits: decimalPlaces, // No decimal places
    }).format(amount);
  }